import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { AppProvider } from '@shopify/polaris';
import { Provider } from '@shopify/app-bridge-react';

import Layout from './containers/layout';
import Auth from './screens/auth/';
import Install from './screens/auth/install';
import Paid from './screens/auth/paid';
import ErrorPage from './screens/auth/error';

import { login, logout } from './actions';

// layout routes
import Home from './screens/home';
import Support from './screens/support';
import Version from './screens/auth/version';
import UpdateVersion from './screens/auth/update';

class App extends React.Component {

    requireAuth = async () => {
        return this.props.shop.loggedIn;
    }
    
    render() {
        try {        
            return (
                <Router>
                    <Switch>
                        <Route path="/admin/" render={() => {
                            const config = {
                                apiKey: process.env.REACT_APP_API_KEY, 
                                shopOrigin: this.props.shop.info.shop,
                                forceRedirect: false//process.env.REACT_APP_FORCE_REDIRECT
                            };
                            return this.requireAuth() && this.props.shop.info ? (
                                <AppProvider>
                                    <Provider config={config}>
                                        <Layout>
                                            <Route exact path="/admin/" component={Home}/>
                                            <Route exact path="/admin/support" component={Support}/>
                                            <Route exact path="/admin/version" component={Version}/>
                                            <Route exact path="/admin/update" component={UpdateVersion}/>
                                        </Layout>
                                    </Provider>
                                </AppProvider>
                            ) : (
                                <Redirect to="/logout"/>
                            )
                        }}/>
                        <Route exact path="/auth" component={Auth} />
                        <Route exact path="/install" component={Install} />
                        <Route exact path="/paid" component={Paid} />
                        <Route exact path="/error" component={ErrorPage} />
                        <Route component={ErrorPage} />
                    </Switch>
                </Router>
            )
        } catch(e) {
            console.log("Error", e.message);
            return null;
        }
    }
}

const mapStateToProps = state => {
    return state;
}

const mapDispatchToProps =  {
    login,
    logout
}
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);